import { z } from 'zod';

const passwordSchema = z.string()
    .min(8, { message: 'Password must be at least 8 characters' })
    .regex(/.*[a-z].*/, { message: 'There must be at least one lowercase character' })
    .regex(/.*[A-Z].*/, { message: 'There must be at least one uppercase character' })
    .regex(/.*\d.*/, { message: 'There must be at least one numeric character' })
    .regex(/[!@#$%^&*(),.?":{}|<>]/, { message: 'There must be at least one symbol' });

export const resetPasswordSchema = z.object({
    password: passwordSchema,
    password_confirmation: z.string().min(1),
}).refine((values) => {
    return values.password === values.password_confirmation;
}, {
    message: 'forms.generic.password_must_match',
    path: [
        'password_confirmation',
    ],
});

export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>;

export const resetPasswordDefaults = (): { password: string; password_confirmation: string } => {
    return { password: '', password_confirmation: '' };
};
